import React from 'react';

/**
 * The head of the Git page's detail card (redesign 05.10.2026, owner's
 * git-page mock): the name with its state as a pill, one meta line (where it
 * syncs · branch · last sync), notes (an error, progress) and the actions on
 * the right. Every target — a workspace, a folder, a scope — uses it, so the
 * card looks the same whatever is selected.
 *
 * `rootProps` carries the test id and data attributes the target always had
 * (git-linked-row, data-git-ws, data-git-scope …), so selectors keep working.
 */
export default function GitDetailHead({ name, tone = 'idle', status, meta = null, notes = null, actions = null, rootProps = {} }) {
  return (
    <div className="git-dhead" data-tone={tone} {...rootProps}>
      <div className="git-dhead-text">
        <div className="git-dhead-title">
          <h2>{name}</h2>
          {status && (
            <span className={`git-status git-status--${tone}`} data-testid="git-status">
              <i aria-hidden />
              {status}
            </span>
          )}
        </div>
        {meta && <div className="git-dhead-meta">{meta}</div>}
        {notes}
      </div>
      {actions && <div className="git-row-actions">{actions}</div>}
    </div>
  );
}

/** "maya/bookshop · ⑂ main · Last synced 2 min ago" — the parts that are known, separated by dots. */
export function MetaLine({ parts }) {
  const shown = parts.filter(Boolean);
  return shown.map((p, i) => (
    // eslint-disable-next-line react/no-array-index-key
    <React.Fragment key={i}>
      {i > 0 && (
        // Spaced in the text ("maya/bookshop · main", as the list row read); the flex gap does the spacing on screen.
        <span className="git-dhead-sep" aria-hidden>
          {' · '}
        </span>
      )}
      {p}
    </React.Fragment>
  ));
}
